import { atom } from "jotai";
import { atomWithDefault } from "jotai/utils";
import { useAtomValue, useSetAtom } from "jotai";
import {
    groupActivityDetailStaticsList,
    queryGroupActivityStatics
} from "../../../service/group";

//小组活动id
export const activityIdAtom = atom(-1);

export const statusFilterAtom = atom({ status: "all", text: "" });

// 基础数据
export const groupStaticsListAtom = atomWithDefault(async get => {
    const activityId = get(activityIdAtom);
    if (activityId === -1) return;
    return await queryGroupActivityStatics(activityId);
});

// 状态过滤过的数据
export const filteredList = atom(get => {
    const filter = get(statusFilterAtom);
    const groupStaticsList = get(groupStaticsListAtom);

    return groupStaticsList?.groupActivityDetailStaticsList
        .filter(item => {
            if (item.groupName?.indexOf(filter.text.trim()) !== -1) return true;
            if (item.groupId.toString() === filter.text.trim()) return true;
            return false;
        })
        .filter((item: groupActivityDetailStaticsList) => {
            if (filter.status === "all") return true;
            if (filter.status === "judged") return item.hasCorrected === "1";
            if (filter.status === "noJudge")
                return item.status === "2" && item.hasCorrected === "0";
            if (filter.status === "noJoinIn") return item.status !== "2";
        });
});

// 刷新列表数据
export function useUpdateStaticsList() {
    const activityId = useAtomValue(activityIdAtom);
    const updateStaticsList = useSetAtom(groupStaticsListAtom);

    return async () => {
        const data = await queryGroupActivityStatics(activityId);
        updateStaticsList(data);
    };
}

// 已参与的小组列表
export const joinedStudentsAtom = atom(get => {
    const staticsList = get(filteredList);

    return staticsList?.filter(item => item.status === "2");
});
